export default ({message}) => {
    return message && <div className="text-red-600 bg-[rgba(255,255,255,0.05)] p-2 text-sm rounded w-full">{message}</div>
}